<p-dialog
    [attr.aria-label]="'global.search.placeholder' | artemisTranslate"
    [visible]="overlay.isOpen()"
    (visibleChange)="$event ? overlay.open() : overlay.close()"
    (onHide)="onDialogHide()"
    (onShow)="focusInput()"
    [modal]="true"
    [closable]="true"
    [showHeader]="false"
    [closeOnEscape]="false"
    [dismissableMask]="true"
    contentStyleClass="p-0 flex flex-col h-full overflow-hidden"
    position="center"
    styleClass="global-search-dialog"
>
    <!-- Search Input Container -->
    <jhi-global-search-input
        [searchQuery]="searchQuery()"
        [chips]="chips()"
        [isLoading]="isLoading()"
        [operator]="operator()"
        [operatorValueValid]="operatorValueValid()"
        [operatorUnknown]="deadEnd()"
        [menuVisible]="filterMenuOpen()"
        [activeOptionId]="activeOptionId()"
        [resultsListboxId]="resultsListboxId()"
        [activeResultId]="activeResultId()"
        [filterShortcutLabel]="filterShortcutLabel()"
        [filterDisabled]="filterTriggerDisabled()"
        (searchInput)="onSearchInput($event)"
        (chipRemoved)="onChipRemoved($event)"
        (chipSelected)="onChipSelected($event)"
        (backspaceAtStart)="onBackspaceAtStart($event)"
        (filterTrigger)="openFilterPicker()"
    />
    <!-- Results Area — also hosts the filter menu while a filter is being composed (no overlay dropdown). -->
    <div class="results-container">
        @if (filterMenuOpen()) {
            <jhi-global-search-filter-menu
                [options]="menuOptions()"
                [activeIndex]="menuActiveIndex()"
                [headerKey]="menuHeaderKey()"
                [message]="deadEndMessage()"
                [emptyReasonKey]="emptyMenuReasonKey()"
                [exclude]="operator()?.negate ?? false"
                [showBack]="!!backDestination()"
                (optionSelected)="onOptionSelected($event)"
                (optionHovered)="onOptionHovered($event)"
                (back)="onFilterBack()"
            />
        } @else if (overlay.isOpen()) {
            <jhi-global-search-navigation-view
                [searchQuery]="searchQuery()"
                [selectedIndex]="selectedIndex()"
                [results]="results()"
                [hasSearched]="hasSearched()"
                [showResults]="showResults()"
                [isLoading]="isLoading()"
                [searchError]="searchError()"
                [contentSearchActive]="contentSearchActive()"
                [courseIds]="courseIdsParam()"
                [excludeCourseIds]="excludeCourseIdsParam()"
                [contentPreview]="contentPreview()"
                (showContentHits)="showContentHits()"
                [canShowMore]="canShowMore()"
                (showMore)="showMoreResults()"
            />
        }
    </div>
    <!-- Keyboard hints footer -->
    <div class="search-footer shrink-0 text-start">
        <div class="keyboard-hints flex items-center justify-between w-full gap-3">
            <span class="flex items-center gap-1">
                <span class="flex items-center gap-1">
                    <kbd class="key-hint-small inline-flex items-center font-mono border" [attr.aria-label]="'global.search.arrowUpAriaLabel' | artemisTranslate">
                        <fa-icon [icon]="faArrowUp" aria-hidden="true" />
                    </kbd>
                    <kbd class="key-hint-small inline-flex items-center font-mono border" [attr.aria-label]="'global.search.arrowDownAriaLabel' | artemisTranslate">
                        <fa-icon [icon]="faArrowDown" aria-hidden="true" />
                    </kbd>
                </span>
                <span class="ms-2">{{ 'global.search.toNavigate' | artemisTranslate }}</span>
            </span>
            <span class="flex items-center gap-1">
                <kbd class="key-hint-small inline-flex items-center font-mono border" aria-label="Escape">ESC</kbd>
                <span class="ms-2">{{ escapeHintKey() | artemisTranslate }}</span>
            </span>
        </div>
    </div>
</p-dialog>
